<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title11"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781429933391_tp01" id="toctitle9" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_part" href="#/e9781429933391_p01" id="toctitle1"><span><em class="i"><strong class="b">Part One</strong></em></span></a><br/>
<span class="toc_entry_part" href="#/e9781429933391_p02" id="toctitle2" title="Link target outside of Sample"><span><em class="i"><strong class="b">Part Two</strong></em></span></span><br/>
<span class="toc_entry_part" href="#/e9781429933391_p03" id="toctitle3" title="Link target outside of Sample"><span><em class="i"><strong class="b">Part Three</strong></em></span></span><br/>
<span class="toc_entry_part" href="#/e9781429933391_p04" id="toctitle4" title="Link target outside of Sample"><span><em class="i"><strong class="b">Part Four</strong></em></span></span><br/>
<span class="toc_entry_part" href="#/e9781429933391_p05" id="toctitle5" title="Link target outside of Sample"><span><em class="i"><strong class="b">Part Five</strong></em></span></span><br/>
<span class="toc_entry_frontMatter" href="#/e9781429933391_fm01" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">AUTHOR’S NOTE</strong></span></span><br/>
<span class="toc_entry_frontMatter" href="#/e9781429933391_fm02" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">Additional Praise for <em class="i">The Empress of Weehawken</em></strong></span></span><br/>
<span class="toc_entry_aboutAuthorPage" href="#/e9781429933391_ata01" id="toctitle12" title="Link target outside of Sample"><span>About the Author</span></span><br/>
<span class="toc_entry_backMatter" href="#/e9781429933391_bm01" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">Discussion Questions for <em class="i">The Empress of Weehawken</em></strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781429933391_cop01" id="toctitle10" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429933391_toc01.vue?3cec11df